// Imports
import React from 'react';
import styled, { css } from 'styled-components/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { useAppSelector } from '../../../../../../../shareables/foundation/front-end/redux/hooks';
import ConditionalTooltip from '../conditional-tooltip';
import useMemberCheck from '../../../../../../../utils/use-member-check';


// Styled components
const Wrapper = styled.div`
	margin-bottom: 1.25rem;
`;

const Button = styled.button<{ opened?: boolean }>`
	background-color: #fff;
	border-color: #ccc;
	padding: 0.375rem 0.75rem;
	font-size: 0.875rem;
	line-height: 1.42857143;
	text-align: center;
	vertical-align: middle;
	cursor: ${(props) => (props.disabled ? 'cursor' : 'pointer')};
	font-family: inherit;
	border: 0.0625rem solid #ccc;
	border-radius: 0.25rem;
	
	&:hover {
		${(props) =>
			!props.opened &&
			!props.disabled &&
			css`
				background-color: #e6e6e6;
			`}
	}
	
	.svg-inline--fa {
		padding-right: 0.25em;
	}
`;


// Define the accepted props
interface Props {
	text: string;
	opened: boolean;
	onClick: () => void;
	icon: IconDefinition;
	iconSize?: SizeProp;
}


// Function component
const UserControlButton: React.FC<Props> = ({ text, opened, onClick, icon, iconSize }) => {
	// Use Redux functionality
	const member = useAppSelector((state) => state.self.member);
	const isDisabled = useMemberCheck({ type: 'ACCOUNT_ISSUE' });
	
	
	// Return JSX
	return (
		<Wrapper>
			<ConditionalTooltip
				content={`A website administrator must ${member?.account.suspended ? 'reinstate' : 'approve'} your account before you can interact with this page.`}
				show={isDisabled}
			>
				<Button onClick={onClick} opened={opened} disabled={isDisabled}>
					<FontAwesomeIcon icon={icon} size={iconSize ?? '1x'} />
					{text}
				</Button>
			</ConditionalTooltip>
		</Wrapper>
	);
};

export default UserControlButton;
